import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { LazyComponentWithSuspense } from '../components/LazyLoader';

const PageNotFound = LazyComponentWithSuspense(() => import('../pages/PageNotFound/PageNotFound'));
const MeetingHome = LazyComponentWithSuspense(() => import('../pages/Meeting/Home'));
const MeetingRoomPage = LazyComponentWithSuspense(() => import('../pages/Meeting/RoomPage'));

export default function MeetingRoutes() {
  return (
    <Routes>
      <Route path="/" element={<MeetingHome />} />
      <Route path="/:code" element={<MeetingRoomPage />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
}
